import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import FileList from '../../../FileList';
import Loading from '../../../Loading';
import Pagination from '../../../Pagination';

const DocumentList = ({
    loading,
    page,
    total,
    list,
    count,
    init,
    search
}) => {
    const onPageChange = useCallback((newPage) => {
        search({
            page: newPage
        });
    }, [search]);

    useEffect(() => {
        init();
    }, [init]);

    return (
        <div className="ibox">
            <div className="ibox-content">
                {loading ? <Loading center={true} /> : <FileList list={list}/>}
                <Pagination
                    onPageChange={onPageChange}
                    initialPage={page}
                    totalPages={total}
                    loading={loading}
                    itemsCountPerPage={count}
                    align={'right'}
                />
            </div>
        </div>
    );
};

DocumentList.propTypes = {
    loading: PropTypes.bool,
    page: PropTypes.number,
    total: PropTypes.number,
    list: PropTypes.array,
    count: PropTypes.number,
    init: PropTypes.func,
    search: PropTypes.func
};

DocumentList.defaultProps = {
    loading: false,
    page: 1,
    total: 0,
    list: [],
    count: 10,
    init: () => {},
    search: () => {}
};

export default DocumentList;
